import React from 'react'
import { Container } from './Loading.styled'

type Props = {
  children?: React.ReactNode
  backgroundColor?: string
  backgroundImage?: string
  height?: string
  width?: string
  isAnimationDisabled?: boolean
}

export const Loading = ({
  children,
  backgroundColor,
  height,
  width,
  backgroundImage,
  isAnimationDisabled = false,
}: Props) => {
  return (
    <Container
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      height={height}
      width={width}
      isAnimationDisabled={isAnimationDisabled}
    >
      {children}
    </Container>
  )
}
